import React from 'react';
import PropTypes from 'prop-types';
import ContactFormModal from './contact-form-modal';
import ErrorBoundary from '../../shared/error-boundary';

export default class ContactFormModalButton extends React.Component {
  static propTypes = {
    hideSubject: PropTypes.bool,
    subject: PropTypes.string,
    message: PropTypes.string,
    modalTitle: PropTypes.string,
    buttonTitle: PropTypes.string,
  };

  static defaultProps = {
    hideSubject: false,
    subject: '',
    message: '',
    modalTitle: 'Contact us',
    buttonTitle: 'Contact us',
  };

  render() {
    return (
      <ErrorBoundary>
        <ContactFormModal
          ref={c => (this.contactFormModal = c)}
          hideSubject={this.props.hideSubject}
          subject={this.props.subject}
          message={this.props.message}
          title={this.props.modalTitle}
        />
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => this.contactFormModal.present()}
        >
          {this.props.buttonTitle}
        </button>
      </ErrorBoundary>
    );
  }
}
